/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISiloConvexStateChangesHandler,
  ISiloConvexStateChangesHandlerInterface,
} from "../ISiloConvexStateChangesHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_firstToCheckpoint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_secondToCheckpoint",
        type: "address",
      },
    ],
    name: "beforeBalanceUpdate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wrapper",
        type: "address",
      },
    ],
    name: "checkUnderlyingToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ISiloConvexStateChangesHandler__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloConvexStateChangesHandlerInterface {
    return new utils.Interface(_abi) as ISiloConvexStateChangesHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloConvexStateChangesHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ISiloConvexStateChangesHandler;
  }
}
